export const config = {
  coin: {
    alpha: {
      start: 1,
      end: 1,
    },
    scale: {
      start: 1,
      end: 0.5,
      minimumScaleMultiplier: 0.9,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 140,
      end: 20,
      minimumSpeedMultiplier: 2,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 250,
      max: 290,
    },
    noRotation: false,
    rotationSpeed: {
      min: -100,
      max: 100,
    },
    lifetime: {
      min: 1.6,
      max: 1.6,
    },
    blendMode: 'normal',
    frequency: 0.1,
    emitterLifetime: -1,
    maxParticles: 200000,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: true,
    spawnType: 'rect',
    spawnRect: {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    },
  },
  confetti: {
    alpha: {
      start: 1,
      end: 1,
    },
    scale: {
      start: 0.5,
      end: 0.4,
      minimumScaleMultiplier: 0.9,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 140,
      end: 20,
      minimumSpeedMultiplier: 2,
    },
    acceleration: {
      x: 0,
      y: 400,
    },
    maxSpeed: 0,
    startRotation: {
      min: 250,
      max: 290,
    },
    noRotation: false,
    rotationSpeed: {
      min: -100,
      max: 100,
    },
    lifetime: {
      min: 1.2,
      max: 1.2,
    },
    blendMode: 'normal',
    frequency: 0.001,
    emitterLifetime: -1,
    maxParticles: 60,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: true,
    spawnType: 'rect',
    spawnRect: {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    },
  },
  dollar: {
    alpha: {
      start: 1,
      end: 1,
    },
    scale: {
      start: 0.2,
      end: 0.7,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 200,
      end: 400,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 0,
      max: 360,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 1.9,
      max: 3.5,
    },
    blendMode: 'normal',
    frequency: 0.1,
    emitterLifetime: -1,
    maxParticles: 30,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: true,
    spawnType: 'circle',
    spawnCircle: {
      x: 0,
      y: 0,
      r: 5,
    },
  },
}
